export default "__VITE_ASSET__B0Xzr3m7__"